import Alerts from "../web/components/Alerts/Alerts";

export const copyText = (text) => {
  navigator.clipboard.writeText(text).then(() => {
    return Alerts({
      title: "Informacion copiada!", type: 'success'
    })
  }).catch(err => {
    console.error("Error al copiar: ", err);
  });
}